export const environment = {
    production: false,
    apiUrl: 'https://backend.tlgos.test.wikipiedra.asmws.net'
};
